// extracted by mini-css-extract-plugin
export var card = "_6l-0";
export var expandedCard = "_6l-2";
export var paginated = "_6l-1";